var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4455 3.84766H4.28843C3.24153 3.84766 2.39124 4.6271 2.39124 5.58675V20.2609C2.39124 21.2206 3.24153 22 4.28843 22H15.4455C16.4924 22 17.3427 21.2206 17.3427 20.2609V5.58675C17.3378 4.6271 16.4875 3.84766 15.4455 3.84766ZM16.0107 20.2564C16.0107 20.5448 15.7552 20.7791 15.4406 20.7791H4.28351C3.96895 20.7791 3.71337 20.5448 3.71337 20.2564V5.58675C3.71337 5.2984 3.96895 5.06412 4.28351 5.06412H15.4406C15.7552 5.06412 16.0107 5.2984 16.0107 5.58675V20.2564Z",
    fill: "#27282A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7117 0H8.55467C7.50777 0 6.65747 0.779439 6.65747 1.73909C6.65747 2.077 6.95237 2.34733 7.321 2.34733C7.68962 2.34733 7.98452 2.077 7.98452 1.73909C7.98452 1.45075 8.2401 1.21647 8.55467 1.21647H19.7117C20.0263 1.21647 20.2819 1.45075 20.2819 1.73909V16.4133C20.2819 16.7016 20.0263 16.9359 19.7117 16.9359C19.3431 16.9359 19.0482 17.2062 19.0482 17.5441C19.0482 17.882 19.3431 18.1524 19.7117 18.1524C20.7586 18.1524 21.6089 17.3729 21.6089 16.4133V1.73909C21.6089 0.779439 20.7586 0 19.7117 0Z",
    fill: "#27282A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.62f788eee825f0d1b1350487e8c179f6.svg";
export { ForwardRef as ReactComponent };